import { useQuery } from '@tanstack/react-query';
import eduzzAccountsService from 'v2/services/eduzzAccount';

export function useGetFeatureAccess() {
  return useQuery({
    queryKey: ['feature-access'],
    queryFn: () => eduzzAccountsService.getFeatureAccessData()
  });
}
